export const GET = Object.freeze({
  REQUEST: 'equipmentModel/GET_REQUEST',
  SUCCESS: 'equipmentModel/GET_SUCCESS',
  ERROR: 'equipmentModel/GET_ERROR',
});

export const FIND = Object.freeze({
  REQUEST: 'equipmentModel/FIND_REQUEST',
  SUCCESS: 'equipmentModel/FIND_SUCCESS',
  ERROR: 'equipmentModel/FIND_ERROR',
});

export const CREATE = Object.freeze({
  REQUEST: 'equipmentModel/CREATE_REQUEST',
  SUCCESS: 'equipmentModel/CREATE_SUCCESS',
  ERROR: 'equipmentModel/CREATE_ERROR',
});

export const UPDATE = Object.freeze({
  REQUEST: 'equipmentModel/UPDATE_REQUEST',
  SUCCESS: 'equipmentModel/UPDATE_SUCCESS',
  ERROR: 'equipmentModel/UPDATE_ERROR',
});

export const DELETE = Object.freeze({
  REQUEST: 'equipmentModel/DELETE_REQUEST',
  SUCCESS: 'equipmentModel/DELETE_SUCCESS',
  ERROR: 'equipmentModel/DELETE_ERROR',
});

export const GET_EQUIPMENT_MODELS_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET.ERROR,
    payload,
    error: true,
  }),
});

export const FIND_EQUIPMENT_MODEL_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: FIND.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: FIND.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: FIND.ERROR,
    payload,
    error: true,
  }),
});

export const CREATE_EQUIPMENT_MODEL_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: CREATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: CREATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: CREATE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_EQUIPMENT_MODEL_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE.ERROR,
    payload,
    error: true,
  }),
});

export const DELETE_EQUIPMENT_MODEL_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: DELETE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: DELETE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: DELETE.ERROR,
    payload,
    error: true,
  }),
});
